export default "__VITE_ASSET__CvCObGOi__"